/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './ExploreAllQuickPromos.scss';

import * as React from 'react';

import { SearchActions, useBreakpoint } from 'sarsaparilla';

import { quickPromos } from 'site-kit';

import { QuickPromo } from './QuickPromo';

interface ExploreAllQuickPromosProps {
    search: (...args: Parameters<typeof SearchActions.submitSimpleSearch>) => void;
}

export function ExploreAllQuickPromos({ search }: ExploreAllQuickPromosProps) {
    const { isSmAndDown } = useBreakpoint();

    const searchInventory = React.useCallback(
        (type: string[]) => () => {
            let { searchAcrossUS } = process.env.HOMEPAGE_OPTIONS;
            const { bounds } = process.env.SEARCH;

            if (!searchAcrossUS && !bounds) {
                // default to search across us for some inventory types
                searchAcrossUS =
                    type.length > 0 &&
                    (type[0] === 'permits' ||
                        type[0] === 'tours' ||
                        type[0] === 'timedentry_tours');
            }

            search(
                '',
                type,
                null,
                null,
                null,
                searchAcrossUS,
                // @ts-ignore - inferred types are incorrect
                bounds
            );
        },
        [search]
    );

    return (
        <section
            className="nav--explore-all-quick-promos"
            aria-label="Explore All Quick Promos"
        >
            <div className="promo-grid">
                {quickPromos.map((promo, idx) => {
                    return (
                        <div className="promo-item" key={idx}>
                            {promo.url ? (
                                <QuickPromo
                                    label={promo.title}
                                    labelType={promo.labelType}
                                    href={promo.url}
                                    imagePath={
                                        isSmAndDown ? promo.mobileImage : promo.image
                                    }
                                    gaTrackingId="333772950269"
                                />
                            ) : (
                                <QuickPromo
                                    label={promo.title}
                                    labelType={promo.labelType}
                                    onClick={searchInventory(promo?.inventoryType)}
                                    imagePath={
                                        isSmAndDown ? promo.mobileImage : promo.image
                                    }
                                    gaTrackingId="333772950269"
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}

// cSpell:ignore activitypass, dayuse, timedentry, sarsa
